import moment from 'moment';

export const POLICY_HOLDER_MIN_AGE = 18;

export const POLICY_HOLDER_UNDERAGE_WARNING = `El titular es menor de ${POLICY_HOLDER_MIN_AGE} años. Verifica la fecha de nacimiento.`;

// Non-blocking check: it only drives a warning message, never a form rule.
export const isUnderPolicyHolderMinAge = (birthday) =>
  Boolean(birthday) &&
  moment().diff(moment(birthday), 'years') < POLICY_HOLDER_MIN_AGE;

// Birthdays cannot be in the future.
export const isFutureDate = (current) =>
  Boolean(current) && current > moment().endOf('day');
